let locales = {
    //companiesChangePassword_: '',
    companiesChangePassword_title: 'Cambiar contraseña',
    companiesChangePassword_newPassword: 'Nueva contraseña',
    companiesChangePassword_repeatPassword: 'Repetir contraseña',
    companiesChangePassword_message: 'Las contraseñas no coinciden',
};

export default locales;